<template>
  <main id="main-container">
    <Hero title="Dispositivos" page="Dispositivos" />
    <div class="content">
      <!-- FORM ADD DEVICE -->
      <div class="row">
        <Card>
          <template v-slot:header>
            <h4 class="card-title">Agregar Nuevo Dispositivo</h4>
          </template>

          <div class="row">
            
            <div class="col-sm-12 col-md-4">
              <label class="form-label">Nombre del Dispositivo</label>
              <input
                class="form-control"
                type="text"
                placeholder="Ex: Home, Office..."
                v-model="newDevice.name"
              />
            </div>

            <div class="col-md-4 col-sm-12">
              <label class="form-label">Identificador Dispositivo</label>
              <input
                class="form-control"
                type="text"
                placeholder="Ex: 7777-8888"
                v-model="newDevice.dId"
              />
            </div>

            <div class="col-md-4 col-sm-12">
              <label class="form-label"
                >Seleccionar Plantilla</label
              >
              <select
                class="form-select"
                v-model="selectedIndexTemplate"
              >
                <option
                  v-for="(template, index) in templates"
                  v-bind:key="template._id"
                  :value="index"
                >
                  {{ template.name }}
                  {{ template.is_global ? "(Global)" : "" }}
                </option>
                <option :value="-404">
                  --- Generar Automaticamente ---
                </option>
              </select>

            </div>
            <div class="col-md-4 col-sm-12">
              <label class="form-label">Latitud</label>
              <input
                class="form-control"
                type="number"
                placeholder="Ex: 10.96815"
                v-model="newDevice.location.lat"
              />
            </div>

            <div class="col-md-4 col-sm-12">
              <label class="form-label">Longitud</label>
              <input
                class="form-control"
                label="Longitud"
                type="number"
                placeholder="Ex: -70.654"
                v-model="newDevice.location.lng"
              />
            </div>
          </div>
          <div id="map-wrap" style="height: 50vh" class="mt-4">
            <client-only>
              <l-map :zoom="m.zoom" :center="m.center">
                <l-circle-marker :lat-lng="m.my_position" v-if="my_position" />
                <l-tile-layer
                  url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                ></l-tile-layer>
                <l-marker
                  v-on:moveend="setLatLng"
                  :draggable="true"
                  :lat-lng="newDevice.location"
                ></l-marker>
              </l-map>
            </client-only>
          </div>
          <br />
          <div class="row pull-right">
            <div class="col-12">
              <button @click="createNewDevice()" class="btn btn-primary">
                Crear
              </button>
            </div>
          </div>
        </Card>
      </div>

      <!-- DEVICES TABLE -->
      <div class="row">
        <Card>
          <template v-slot:header>
            <h4 class="card-title">Dispositivos</h4>
          </template>

          <div class="table-responsive">
            <table class="table table-bordered table-striped table-vcenter">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Identificador</th>
                  <th>Contraseña</th>
                  <th>Plantilla</th>
                  <th>Mqtt Info</th>
                  <th class="text-center" style="width: 100px">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(dev, index) in $store.state.devices"
                  v-bind:key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ dev.name }}</td>
                  <td>{{ dev.dId }}</td>
                  <td>{{ dev.password }}</td>
                  <td>{{ dev.templateName }}</td>
                  <td>
                    <div class="d-flex justify-content-center">
                      <button
                        type="button"
                        class="btn btn-sm btn-alt-primary js-bs-tooltip-enabled"
                        data-bs-toggle="tooltip"
                        data-bs-original-title="Borrar"
                        @click="getDeviceCredentials(dev.dId)"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                    </div>
                  </td>
                  <td>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="dev.saverRule.status"
                        type="checkbox"
                        @click="updateSaverRuleStatus(dev.saverRule)"
                      />
                      <button
                        type="button"
                        class="btn btn-sm btn-alt-danger js-bs-tooltip-enabled"
                        data-bs-toggle="tooltip"
                        title=""
                        data-bs-original-title="Borrar"
                        @click="
                          showAlertConfirm(
                            'Eliminar',
                            '¿Está seguro de Eliminar el dispositivo?',
                            'question',
                            dev
                          )
                        "
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>
  </main>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LControlScale,
} from "@vue-leaflet/vue-leaflet";
import axios from "@/axios";
import useApp from "@/composables/useApp";
export default {
  middleware: "authenticated",
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LMarker,
    LControlScale,
  },
  data() {
    return {
      id_template: "",
      templates: [],
      selectedIndexTemplate: null,
      newDevice: {
        name: "",
        dId: "",
        templateId: "",
        templateName: "",
        location: { lat: 0, lng: 0 },
        ext_mqtt: false,
      },
      my_position: false,
      m: {
        my_position: { lat: 0, lng: 0 },
        center: { lat: 0, lng: 0 },
        zoom: 5,
      },
    };
  },
  mounted() {
    const {
      ToastMsgSuccess,
      ToastMsgInfo,
      ToastMsgWarning,
      ToastMsgError,
      ToastMsg,
    } = useApp();
    this.ToastMsgSuccess = ToastMsgSuccess;
    this.ToastMsg = ToastMsg;
    this.ToastMsgInfo = ToastMsgInfo;
    this.ToastMsgError = ToastMsgError;
    this.ToastMsgWarning = ToastMsgWarning;
    this.showAlertConfirm = (title, text, icon, dev) => {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteDevice(dev);
        }
      });
    };
    this.showMqttCredentials = (credentials) => {
      const dataCopy = JSON.stringify({
        server: process.env.VUE_APP_MQTT_HOST,
        port: 1883,
        username: credentials.username,
        password: credentials.password,
        publish: credentials.publish[0],
        subscribe: credentials.subscribe[0],
      });
      const html = `
      <b>servidor</b>: ${process.env.VUE_APP_MQTT_HOST}<br>
      <b>Usuario</b>: ${credentials.username} <br>
      <b>Clave</b>: ${credentials.password} <br>
      <b>puerto</b>: 1883 <br>
      <b>publicar</b>: ${credentials.publish} <br>
      <b>suscribir</b>: ${credentials.subscribe} <br>
      `;
      this.$swal({
        title: "Credenciales Mqtt",
        html,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Copiar Portapapeles",
        cancelButtonText: "Salir",
      }).then((result) => {
        if (result.isConfirmed) {
          navigator.clipboard
            .writeText(dataCopy)
            .then(() => {
              this.ToastMsgInfo("Copiado al Portapapeles", "server", 5000)
            })
            .catch((error) => {
              this.ToastMsgError("Error al Intentar Copiar", "server", 5000)
              console.error("Error al copiar JSON:", error);
            });
        }
      });
    };

    this.getTemplates();
    this.geolocate();
  },
  methods: {
    getDeviceCredentials(dId) {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };
      this.$axios
        .post("/deviceCredentials", { dId }, axiosHeaders)
        .then((res) => {
          if (res.status == 200) {
            this.showMqttCredentials(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setLatLng({ target }) {
      this.newDevice.location = target._latlng;
    },

    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        // console.log(position)
        const my_position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.m.center = my_position;
        this.m.my_position = JSON.parse(JSON.stringify(my_position));
        this.newDevice.location = JSON.parse(JSON.stringify(my_position));
        this.m.zoom = 12;
        this.my_position = true;
      });
      return this.m.center;
    },

    updateSaverRuleStatus(rule) {
      var ruleCopy = JSON.parse(JSON.stringify(rule));

      ruleCopy.status = !ruleCopy.status;

      const toSend = {
        rule: ruleCopy,
      };

      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      axios
        .put("/saver-rule", toSend, axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            let msg = ruleCopy.status
              ? "Monitoreo Activado"
              : "Monitoreo Desactivado";
            this.$store.dispatch("getDevices");
            ruleCopy.status
              ? this.ToastMsgSuccess(msg, "server", 5000)
              : this.ToastMsgWarning(msg, "server", 5000);
          }

          return;
        })
        .catch((e) => {
          console.log(e);
          this.ToastMsgWarning(
            "Error Actualizando Reglas de guardado",
            "server",
            5000
          );
          return;
        });
    },
    //new device
    async createNewDevice() {
      if (this.newDevice.name == "") {
        this.ToastMsgWarning("Nombre Vacio", "user", 5000);
        return;
      }

      if (this.newDevice.dId == "") {
        this.ToastMsgWarning("Campo Id Vacio :( ", "user", 5000);
        return;
      }

      if (this.selectedIndexTemplate == null) {
        this.ToastMsgWarning("Selecciona un Plantilla !", "user", 5000);
        return;
      }

      if (
        this.newDevice.location.lat == 0 &&
        this.newDevice.location.lng == 0
      ) {
        this.ToastMsgWarning("Marca Una Ubicacion en el Mapa", "map", 5000);
        return;
      }

      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      //ESCRIBIMOS EL NOMBRE Y EL ID DEL TEMPLATE SELECCIONADO EN EL OBJETO newDevice

      if (this.templates[this.selectedIndexTemplate].is_global){
        await this.saveTemplate(true)
        this.newDevice.templateId = this.id_template;
        this.newDevice.templateName = this.templates[this.selectedIndexTemplate].name;
        console.log("Esto es Global !!!")
      } 
      else if (this.selectedIndexTemplate != -404) {
        this.newDevice.templateId =
          this.templates[this.selectedIndexTemplate]._id;
        this.newDevice.templateName =
          this.templates[this.selectedIndexTemplate].name;
      } else {
        if (await this.saveTemplate()) {
          this.newDevice.templateId = this.id_template;
          this.newDevice.templateName = `${this.newDevice.name}-Automatic`;
        } else {
          this.ToastMsgError(
            "Error Al Crear Plantilla Automaticamente",
            "server",
            3000
          );
          return;
        }
      }

      const toSend = {
        newDevice: this.newDevice,
      };

      axios
        .post("/device", toSend, axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.$store.dispatch("getDevices");
            this.newDevice.name = "";
            this.newDevice.dId = "";
            this.selectedIndexTemplate = null;
            this.ToastMsgSuccess("Dispositivo Creado !", "grin-beam", 5000);
            return;
          }
        })
        .catch((e) => {
          console.log(e.response)
          if (
            e.response.data.status == "error" &&
            e.response.data.error.errors.dId.kind == "unique"
          ) {
            this.ToastMsgError(
              "Dispositivo Ya registrado Intente con otro <Identificador>",
              " frown-open",
              5000
            );
            return;
          } else {
            this.ToastMsgWarning("Error en Servidor", "server", 5000);
            return;
          }
        });
    },

    //Get Templates
    async getTemplates() {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
        params: {
            all: "true"
          }
      };

      try {
        const res = await axios.get("/template", axiosHeaders);

        if (res.data.status == "success") {
          this.templates = res.data.data;
        }
      } catch (error) {
        this.ToastMsgError("Error cargando Templates !", "frown", 5000);
        console.log(error);
        return;
      }
    },

    async saveTemplate(is_global = false) {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };
      let toSend = {};

      if (is_global){
        const templateData = this.templates[this.selectedIndexTemplate]
        toSend = {
          template: {
            name: templateData.name,
            description: templateData.description,
            widgets: templateData.widgets
          }
        }

      }else {
        toSend = {
          template: {
            name: `${this.newDevice.name}-Automatic`,
            description: `Generado Automaticamente ${this.newDevice.name}`,
            widgets: [],
          },
        } 
      }

      try {
        const res = await axios.post("/template", toSend, axiosHeaders);
        if (res.data.status == "success") {
          this.ToastMsgInfo("Plantilla Creada !", "save", 5000);
          this.id_template = res.data.templateId;
          return true;
        }
        return false;
      } catch (error) {
        this.ToastMsgError("Error Creando Plantilla", "server", 5000);
        console.log(error);
        return false;
      }
    },

    deleteDevice(device) {
      const axiosHeader = {
        headers: {
          token: this.$store.state.auth.token,
        },
        params: {
          dId: device.dId,
        },
      };

      axios
        .delete("/device", axiosHeader)
        .then((res) => {
          if (res.data.status == "success") {
            this.ToastMsgWarning(
              `Dispositivo ${device.name} Borrado`,
              "grin",
              5000
            );
            this.$store.dispatch("getDevices");
          }
        })
        .catch((e) => {
          console.log(e);
          this.ToastMsgError(
            `Error al intentar Borrar ${device.name}`,
            "frown-open",
            5000
          );
        });
    },
  },
};
</script>
